module.exports = __webpack_public_path__ + "static/media/ExodusBg.68107380.png";